
<template>
  <div v-wechat-title="titleTop">
    <NativeBar ref="menu" v-model="NativeBarId" />
    <div class="topRect" :style="'background: linear-gradient(left bottom,'+GetColorMainGradual()+','+GetColorMain()+');background: -webkit-linear-gradient(left bottom,'+GetColorMainGradual()+','+GetColorMain()+');'">
      <div class="info">
        <van-row>
          <van-col span="8">
            <van-image
              v-if="userData"
              round
              width="4em"
              height="4em"
              fit="cover"
              :src="userData.proIcon?userData.proIcon:'/img/defaultIcon.jpg'"
            />
          </van-col>
          <van-col v-if="userData" span="14" class="userName">
            <span>{{ GetSysTitle() }}</span><br>
            <span class="vipLevelRect">{{ userData.nickName }}[{{ userData.isCoach?"教练":"专业用户" }}]</span>
            <div class="userMoneyRect">
              <i class="iconfont iconproye" />
              <span>{{ ShowMoney(data.totalMoney) }}</span>
              &nbsp;&nbsp;
              <i class="iconfont iconproyedj" />
              <span>{{ ShowMoney(data.totalMoneyFrozen) }}</span></div>
          </van-col>
          <van-col span="2" class="rigth" @click="onGotoPage('')"><i class="iconfont iconsetting" /></van-col>
        </van-row>
      </div>
    </div>

    <div class="storeRect">
      <div class="orderLine">
        <div v-if="CheckSystemType('DiveBoss')" class="orderRect disable" @click="onGotoPage('')">
          <i class="iconfont iconprodate" /><br>
          <span>我的日程</span>
        </div>
        <div v-if="CheckSystemType('DiveBoss')" class="orderRect" @click="onGotoPage('/pro/trip/classList')">
          <i class="iconfont iconproteach" /><br>
          <span>我的队伍</span>
          <!-- <div v-if="data && data.totalNeedPay>0" class="num" :style="'background-color: '+GetColorMain()">{{ data.totalNeedPay }}</div> -->
        </div>
        <div class="orderRect disable" @click="onGotoPage('')">
          <i class="iconfont iconproorder" /><br>
          <span>我的订单</span>
        </div>
        <!-- /pro/commission -->
        <div class="orderRect" @click="onGotoPage('/pro/commission')">
          <i class="iconfont iconproMoney" /><br>
          <span>我的佣金</span>
        </div>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="numList">
        <div @click="onGotoPage('/pro/trip/tripList?state=Wait')">
          <span>{{ getDiveStudentNum('Wait') }}</span><br>
          待开始
        </div>
        <div @click="onGotoPage('/pro/trip/tripList?state=FinishTheoretical')">
          <span>{{ getDiveStudentNum('OnTheoretical','FinishTheoretical') }}</span><br>
          理论
        </div>
        <div @click="onGotoPage('/pro/trip/tripList?state=OnCourse')">
          <span>{{ getDiveStudentNum('OnCourse') }}</span><br>
          进行中
        </div>
        <div @click="onGotoPage('/pro/trip/tripList?state=Finished')">
          <span>{{ getDiveStudentNum('Finished') }}</span><br>
          待认证
        </div>
        <div @click="onGotoPage('/pro/trip/tripList?state=Certificateing')">
          <span>{{ getDiveStudentNum('Certificateing') }}</span><br>
          认证中
        </div>
        <div @click="onGotoPage('/pro/trip/tripList?state=Certificate')">
          <span>{{ getDiveStudentNum('Certificate') }}</span><br>
          待评价
        </div>
      </div>
    </div>

    <div v-if="data.moneys.length > 0" class="commissionRect" @click="onGotoPage('/pro/moneyList')">
      <div v-for="(item,index) in data.moneys" :key="index" class="commission">
        <div v-if="!item.icon" class="icon">
          <i class="iconfont iconstatepay" />
        </div>
        <van-image
          v-if="item.icon"
          round
          width="2.5em"
          height="2.5em"
          fit="cover"
          :src="item.icon+'?x-oss-process=style/commodityicon'"
        />
        <div class="info">
          <van-row>
            <van-col span="16">关联号:{{ item.aboutId }}<br>
              <div class="about">{{ item.about }}</div>
            </van-col>
            <van-col span="8" class="rigth">{{ formatDate(item.createTime,"yyyy/MM/dd") }}<br>
              <span class="add"><span v-if="item.price>=0">+</span>{{ ShowMoney(item.price) }} {{ item.currency }}</span>
            </van-col>
          </van-row>

        </div>
      </div>
    </div>

    <div class="buttonRect">
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/pro/userBirthday')">
        <van-row>
          <van-col span="3"><i class="iconfont iconbirthday" /></van-col>
          <van-col span="21">生日顾客关系维护(今日{{ data.birthdayUserNum }}名)</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss') && data && data.masterDiveCenterNum>0" class="line" @click="onGotoPage('/pro/trip/diveStoreStudent')">
        <van-row>
          <van-col span="3"><i class="iconfont iconstoresetting" /></van-col>
          <van-col span="21">潜水中心管理({{ data.masterDiveCenterNum }}个中心)</van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss') && data && data.isExamOpen" class="line" @click="onGotoPage('/pro/examList')">
        <van-row>
          <van-col span="3"><i class="iconfont iconkaoshi" /></van-col>
          <van-col span="21">在线考试<span v-if="data.examOnlineNum>0">({{ data.examOnlineNum }}个进行中)</span></van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('SSI') && data && data.isExamOpen" class="line" @click="showBindWeChatProfitSharing=true">
        <van-row>
          <van-col span="3"><i class="iconfont iconkaoshi" /></van-col>
          <van-col span="21">激活并绑定微信分账
            <span v-if="!data.isBindWeChatProfitSharing"> (未绑定)</span>
            <span v-if="data.isBindWeChatProfitSharing"> (已绑定)</span>
          </van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/pic/picIndex')">
        <van-row>
          <van-col span="3"><i class="iconfont iconpropic" /></van-col>
          <van-col span="21">证书发放管理<span v-if="data.picNum>0">({{ data.picNum }}个待处理)</span></van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onBindThridAccount('PADI',data.padiProId)">
        <van-row>
          <van-col span="3"><i class="iconfont iconrectPADI" /></van-col>
          <van-col span="21">PADI专业用户<span v-if="data.padiProId">({{ data.padiProId }})</span><span v-if="!data.padiProId">(未关联)</span></van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onBindThridAccount('SSI',data.ssiProId)">
        <van-row>
          <van-col span="3"><i class="iconfont iconrectSSI" /></van-col>
          <van-col span="21">SSI专业用户<span v-if="data.ssiProId">({{ data.ssiProId }})</span><span v-if="!data.ssiProId">(未关联)</span></van-col>
        </van-row>
      </div>

      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/pro/aidaHome')">
        <van-row>
          <van-col span="3"><i class="iconfont iconrectAIDA" /></van-col>
          <van-col span="21">
            AIDA专业用户<span v-if="data.aidaInfo && data.aidaInfo.accountName"> ({{ data.aidaInfo.accountName }})</span>
            <span v-if="!data.aidaInfo || !data.aidaInfo.accountName"> (未关联)</span>
          </van-col>
        </van-row>
      </div>
      <div v-if="CheckSystemType('DiveBoss')" class="line" @click="onGotoPage('/pro/propagandalist')">
        <van-row>
          <van-col span="3"><i class="iconfont iconprotj" /></van-col>
          <van-col span="21">宣传资料查看</van-col>
        </van-row>
      </div>
      <div class="line disable" @click="onGotoPage('')">
        <van-row>
          <van-col span="3"><i class="iconfont iconprozbgl" /></van-col>
          <van-col span="21" class="disable">装备推荐管理</van-col>
        </van-row>
      </div>
      <div class="line disable" @click="onGotoPage('')">
        <van-row>
          <van-col span="3"><i class="iconfont iconprojlsz" /></van-col>
          <van-col span="21">教练信息管理</van-col>
        </van-row>
      </div>
      <div class="line disable" @click="onGotoPage('')">
        <van-row>
          <van-col span="3"><i class="iconfont iconprotj" /></van-col>
          <van-col span="21">数据统计</van-col>
        </van-row>
      </div>

    </div>
    <div class="emptyRect" />
    <bindWeChatProfitSharing v-model="showBindWeChatProfitSharing" @reload="init" />
    <setProAccount v-model="showBindThirdAccount" :group-type="bindThridAccountType" @reload="init" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { CheckSystemType } from '@/utils/request'
import { Button, Image } from 'vant'
import NativeBar from '@/components/NativeBar'
import { formatDate, ShowMoney, getUserBase, MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, GetColorMainGradual } from '@/utils/base'
import bindWeChatProfitSharing from '@/components/bindWeChatProfitSharing'
import setProAccount from '@/components/setProAccount'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    NativeBar,
    bindWeChatProfitSharing,
    setProAccount
  },
  data() {
    return {
      NativeBarId: 4,
      titleTop: '专业用户',
      showBindWeChatProfitSharing: false,
      userData: {
        icon: undefined
      },
      data: {
        moneyRects: [{
          money: 0,
          moneyFrozen: 0
        }],
        moneys: [],
        picNum: 0
      },
      bindThridAccountType: undefined,
      showBindThirdAccount: undefined
    }
  },
  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'pro'
    }, 0)
    this.$refs.menu.resetNum()
  },
  created() {
    getUserBase(data => {
      if (data) {
        this.userData = data
      }
    })
    this.init()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'pro'
    }, 0)
  },
  methods: {
    CheckSystemType,
    GetColorMainGradual,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    ShowMoney,
    formatDate,
    onBindThridAccount(type, value) {
      if (value) {
        MyNotify('info', '已经绑定' + type + '专业用户序号，不能自行修改，请联系潜店管理人员!')
        return
      }
      this.bindThridAccountType = type
      this.showBindThirdAccount = true
    },
    onGotoPage(url) {
      if (!url || url === '') {
        MyNotify('info', '功能暂未开放，请稍等!')
        return
      }
      this.$router.push(url)
    },
    getDiveStudentNum(state, state2) {
      if (!this.data || !this.data.studentNumList) {
        return 0
      }
      var list = this.data.studentNumList.filter(item => item.state === state || item.state === state2)
      if (list.length <= 0) {
        return 0
      }
      if (list.length === 1) {
        return list[0].num
      } else {
        return list[0].num + list[1].num
      }
    },
    init() {
      request({
        url: '/pro/getHomePage',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    }
  }
}
</script>
<style scoped>
.topRect{
  color: #fff;
  padding: 0.5em 1.5em;
}
.topRect .userName{
  font-size: 1.1em;
}
.vipLevelRect{
  font-size: 0.8em;
  line-height: 1.5em;
}
.userMoneyRect{
  font-size: 0.8em;
  line-height: 1em;
}
.userMoneyRect i{
  padding-right: 0.1em;
}
.storeRect {
  background-color: #fff;
  margin: 1em 0.5em;
  padding: 1em;
  border-radius: 0.5em;
}
.storeRect .orderLine{
  border-bottom: 1px solid #f1f1f1;
  display:flex;
  padding-bottom: 0.8em;
}
.storeRect .orderLine .orderRect{
  position: relative;
  text-align: center;
  flex:1;
  line-height: 1.5em;
}
.storeRect .orderLine span{
  font-size: 0.9em;
}
.storeRect .orderLine .orderRect .num{
  position:absolute;
  right: 2em;
  top: 0em;
  color: #fff;
  font-size: 0.7em;
  border-radius: 1em;
  text-align: center;
  width: 1.4em;
  height: 1.4em;
  line-height: 1.4em;
}
.storeRect .numList{
  display:flex;
  padding-top: 0.8em;
}
.storeRect .numList div{
  text-align: center;
  flex:1;
  font-size: 0.9em;
  line-height: 1.5em;
}
.storeRect .numList span{
  font-size: 1.5em;
  font-weight: 700;
}

.commissionRect{
  background-color: #fff;
  margin: 1em 0.5em;
  padding: 0.5em 1em;
  border-radius: 0.5em;
}
.commissionRect .commission{
  position: relative;
  height: 2.5em;
  padding: 0.4em 0 ;
  border-bottom: 1px solid #eaeaea;
}
.commissionRect .commission:last-child{
  border-bottom: none;
}

.commissionRect .commission .icon{
    width: 2.5em;
    height: 2.5em;
    background-color: #999;
    border-radius: 2.5em;
    text-align: center;
    line-height: 2.5em;
    color: #fff;
}
.commissionRect .commission img{
  width: 2.5em;
}
.commissionRect .commission .info{
  position: absolute;
  left: 4em;
  top:0.6em;
  right: 0;
  font-size: 0.75em;
}
.commissionRect .commission .info .add{
  color:#f00;
}
.commissionRect .commission .info .about
{
  color: #999;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.buttonRect{
  background-color: #fff;
  margin: 1em 0.5em;
  padding: 0.2em 1em;
  border-radius: 0.5em;
}

.buttonRect .line{
  line-height: 2.5em;
  border-bottom: 1px solid #f1f1f1;
}
.buttonRect .line:last-child
{
   border-bottom:none;
}
.emptyRect{
  height: 3em;
}
.disable{
  color: #999;
}
</style>
